import type { Ref } from 'vue';
import { computed } from 'vue';
import { unref } from 'vue';
import { useQuery } from '@tanstack/vue-query';
import { getApi } from './api';

export type GeofenceRemovalSuggestion = {
  id: string;
  geofence_id: number;
  geofence_name: string;
  geofence_address: string | null;
  last_activity_t: number | null;
  days_since_last_activity: number | null;
  geofence_age_days: number;
  generated_at: string;
};

export default function getAccountGeofenceRemovalSuggestions(
  accountId: Ref<number | null | undefined> | number | null | undefined,
) {
  const query = useQuery({
    queryKey: ['geofence-removal-suggestions', () => unref(accountId)],
    queryFn: async () => {
      const aid = unref(accountId);
      if (aid == null || aid === 0) {
        return { suggestions: [] as GeofenceRemovalSuggestion[], total: 0 };
      }
      const { api, baseURL } = getApi();
      const res = await api.get(
        `api/v2/accounts/${aid}/geofence-removal-suggestions`,
        { baseURL, useOriginalToken: true },
      );
      return {
        suggestions: (res.data?.data ?? []) as GeofenceRemovalSuggestion[],
        total: Number(res.data?.meta?.total ?? 0),
      };
    },
    enabled: () => {
      const aid = unref(accountId);
      return aid != null && aid !== 0;
    },
    staleTime: 5 * 60 * 1000,
  });

  const suggestions = computed(() => query.data.value?.suggestions ?? []);
  const count = computed(() => query.data.value?.total ?? 0);

  return {
    ...query,
    suggestions,
    count,
  };
}
